export const JOB_STATUS_KEYS = [
  'draft',
  'active',
  'paused',
  'resume',
  'closed',
] as const;

export type JobStatusKey = (typeof JOB_STATUS_KEYS)[number];

export const JOB_STATUS_LABELS: Record<JobStatusKey, string> = {
  draft: 'Draft',
  active: 'Active',
  paused: 'Paused',
  resume: 'Resume',
  closed: 'Closed',
} as const;

export function guardJobStatus(status: unknown): JobStatusKey {
  return JOB_STATUS_KEYS.includes(status as JobStatusKey)
    ? (status as JobStatusKey)
    : 'draft';
}
